import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSearch from "@/components/HeroSearch";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Car, Users, MapPin, DollarSign } from "lucide-react";
import { cities } from "@/data/cities";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const Index = () => {
  useDocumentMeta({
    title: "BestPriceRide.com — Find Drivers and Companies Near You",
    description:
      "Find local drivers and transportation companies worldwide. Airport transfers, private drivers, and car services with direct contact and no hidden fees.",
    canonical: "https://bestpriceride.com/",
  });
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <HeroSearch />

      {/* Features section */}
      <section className="py-16 bg-muted/50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Why BestPriceRide?</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { icon: Car, title: "Wide Selection", desc: "Browse hundreds of drivers and companies — your on-demand ride service marketplace." },
              { icon: DollarSign, title: "Best Prices", desc: "Compare ride prices and specials, to find rides near you." },
              { icon: MapPin, title: "Nearby Providers", desc: "Find a ride near me — search by city, zip code, or location for car service near you." },
              { icon: Users, title: "Direct Contact", desc: "Reach out providers directly with no middleman or hidden fees." },
            ].map((f, i) => (
              <div key={i} className="text-center">
                <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                  <f.icon className="h-7 w-7 text-primary" />
                </div>
                <h3 className="font-semibold mb-2">{f.title}</h3>
                <p className="text-sm text-muted-foreground">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Browse by City */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-3">Browse by City</h2>
          <p className="text-center text-muted-foreground mb-8">Find drivers and transportation companies in major cities across the US.</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 max-w-4xl mx-auto">
            {cities.map((c) => (
              <Link
                key={c.slug}
                to={`/cities/${c.slug}`}
                className="flex items-center gap-2 p-3 rounded-lg border hover:bg-muted/50 hover:border-primary/30 transition-colors"
              >
                <MapPin className="h-4 w-4 text-primary shrink-0" />
                <span className="text-sm font-medium">{c.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-muted/50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Are you a driver or company?</h2>
          <p className="text-muted-foreground mb-8 max-w-lg mx-auto">
            Register on BestPriceRide.com to get discovered by customers searching for drivers and companies in your area.
          </p>
          <Link to="/register">
            <Button size="lg">Register as Provider</Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Index;
